import { IAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { getMasterAgentExperience } from './getMasterAgentExperience';
import { getMasterAgent } from './getMasterAgent';

export function getSubAgentExperience(agent: IAgentSchema) {
  const masterAgent = getMasterAgent(agent);
  const subAgentExperience = getMasterAgentExperience(masterAgent);

  return subAgentExperience ? `На рынке с ${subAgentExperience} года` : null;
}
